import axios from "axios";
import nookies, { destroyCookie } from 'nookies'

const API_URL = `${process.env.REACT_APP_API_URL}/auth`;

const signup = (email, password, name, linkedIn) => {
  return axios
    .post(API_URL + "/signup", {
      email,
      password,
      name,
      linkedIn,
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
        // write in cookie
        nookies.set(null, 'user', JSON.stringify(response.data), {
          maxAge: 30 * 24 * 60 * 60,
          path: '/',
        })
      }
      return response.data;
    });
};

const login = (email, password) => {
  return axios
    .post(API_URL + "/login", {
      email,
      password,
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
        // write in cookie
        nookies.set(null, 'user', JSON.stringify(response.data), {
          maxAge: 30 * 24 * 60 * 60,
          path: '/',
        })

      }

      return response.data;
    });
};

const google = (name, email, imageUrl, accessToken) => {
  return axios
    .post(API_URL + "/signup/google", {
      name,
      email,
      imageUrl,
      accessToken,
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
        // write in cookie
        nookies.set(null, 'user', JSON.stringify(response.data), {
          maxAge: 30 * 24 * 60 * 60,
          path: '/',
        })
      }

      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("user");
  destroyCookie(null, "user", { path: '/', });
};

const getCurrentUser = () => {
  let cookies = nookies.get(null, 'user')
  let user = cookies.user
  if (user) {
    console.log(user);
    return JSON.parse(user)
  } else {
    return null
  }
  // return JSON.parse(localStorage.getItem("user"));
  // return JSON.parse(nookies.get(null, 'user'))
};

const authService = {
  signup,
  login,
  logout,
  google,
  getCurrentUser,
};

export default authService;
